module.exports = __webpack_public_path__ + "static/img/qr-code.812914d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qr-code.jpg
// module id = ZJYh
// module chunks = 10